// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3993": "3f525799a689","4299": "ad87e3715186","4879": "66b95d754de6","5061": "aa7cf2cd9645","7636": "e59215512534","7967": "385394621bfc",}[chunkId] + ".css"
}